import { connect } from 'react-redux';
import _merge from 'lodash.merge';
import HomeTemplateComponent from './home-template.component';


const mapStateToProps = (state, ownProps) => {
	const {"series-path": seriesPath, configs} = state.Main;
    const props = _merge({}, ownProps, {
        "imageServer": state.WebView.medscape.config.imageServer,
    	"episodePath": `${seriesPath}${configs[0].path}`,
    	"linksTarget": state.WebView.isIframe === true ? "_blank" : ""
    })
    //console.log("[HomeTemplate] mapStateToProps: props:", props);
    return props;
};
const mapDispatchToProps = dispatch => {
    return {

    }
};

const HomeTemplate = connect(mapStateToProps, mapDispatchToProps)(HomeTemplateComponent);
export default HomeTemplate;